import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppGuard } from '@shared/guards';
import { AppCustomPreloader } from '@shared/preloader/app-custom-preloader';

import { Bracelit404Component } from '@app/shared/bracelit-components/bracelit-404';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', loadChildren: () => import('app/auth/login/login.module').then(m => m.LoginModule), data: { title: 'Login' } },
  {
    path: 'dashboard',
    loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AppGuard],
    data: { title: 'Dashboard' }
  },
  {
    path: 'movimientos',
    loadChildren: () => import('app/profits/profits.module').then(m => m.ProfitsModule),
    canActivate: [AppGuard],
    data: { title: 'Movimientos' }
  },
  {
    path: 'productos',
    loadChildren: () => import('app/products/products.module').then(m => m.ProductsModule),
    canActivate: [AppGuard],
    data: { title: 'Productos' }
  },
  {
    path: 'trabajadores',
    loadChildren: () => import('app/workers/workers.module').then(m => m.WorkersModule),
    canActivate: [AppGuard],
    data: { title: 'Trabajadores' }
  },
  {
    path: 'bonos',
    loadChildren: () => import('app/voucher/voucher.module').then(m => m.VoucherModule),
    canActivate: [AppGuard],
    data: { title: 'Bonos' }
  },

  {
    path: 'recintos',
    loadChildren: () => import('app/rooms/rooms.module').then(m => m.RoomsModule),
    canActivate: [AppGuard],
    data: { title: 'Recintos' }
  },
  {
    path: 'usuarios',
    loadChildren: () => import('app/users/users.module').then(m => m.UsersModule),
    canActivate: [AppGuard],
    data: { title: 'Usuarios' }
  },
  {
    path: 'confEvent',
    loadChildren: () => import('app/confEvent/confEvent.module').then(m => m.ConfEventModule),
    canActivate: [AppGuard],
    data: { title: 'Configuración de Evento' }
  },
  {
    path: 'pedidos',
    loadChildren: () => import('app/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [AppGuard],
    data: { title: 'Pedidos' }
  },
  {
    path: 'actividades',
    loadChildren: () => import('app/activities/activities.module').then(m => m.ActivitiesModule),
    canActivate: [AppGuard],
    data: { title: 'Actividades' }
  },
  {
    path: 'grupos',
    loadChildren: () => import('app/groups/groups.module').then(m => m.GroupsModule),
    canActivate: [AppGuard],
    data: { title: 'Grupos' }
  },
  {
    path: 'consultas',
    loadChildren: () => import('app/data-base/data-base.module').then(m => m.DataBaseModule),
    canActivate: [AppGuard],
    data: { title: 'Consultas' }
  },
  {
    path: 'dispositivos',
    loadChildren: () => import('app/devices/devices.module').then(m => m.DevicesModule),
    canActivate: [AppGuard],
    data: { title: 'Dispositivos' }
  },
  {
    path: 'crear',
    loadChildren: () => import('app/create/create.module').then(m => m.CreateModule),
    canActivate: [AppGuard],
    data: { title: 'Crear' }
  },
  {
    path: 'eventos',
    loadChildren: () => import('@app/events/events.module').then(m => m.EventsModule),
    canActivate: [AppGuard],
    data: { title: 'Eventos' }
  },
  {
    path: 'notificaciones',
    loadChildren: () => import('app/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AppGuard],
    data: { title: 'Notificaciones' }
  },
  {
    path: 'leads',
    loadChildren: () => import('app/lead-scanner/lead-scanner.module').then(m => m.LeadScannerModule),
    canActivate: [AppGuard],
    data: { title: 'Leads' }
  },
  { path: '**', component: Bracelit404Component, data: { animation: { page: 'notFoundPage' } } }
];



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: AppCustomPreloader,
    paramsInheritanceStrategy: 'always',
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule],
  providers: [
    AppGuard
  ]
})

export class AppRoutingModule { }
